import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment-timezone';

import { getTimezoneFromState } from 'helpers/intl';

class IntlDateRelativeRaw extends React.Component {
  getTimezone = () => {
    const { defaultTimezone, timezone } = this.props;
    return timezone || defaultTimezone;
  };

  render() {
    const { date, forwardedRef } = this.props;
    let tzDate = moment.tz(date, 'UTC');
    tzDate = tzDate.tz(this.getTimezone());
    const relativeDatetime = `${tzDate.fromNow()} ${moment(date).format('HH:mm')} Uhr`;

    return (
      <span title={tzDate.format('l LT')} ref={forwardedRef}>
        {relativeDatetime}
      </span>
    );
  }
}

const mapStateToProps = state => {
  return {
    defaultTimezone: getTimezoneFromState(state),
    locale: state.intl.locale,
  };
};

const ConnectedIntlDateRelative = connect(mapStateToProps)(IntlDateRelativeRaw);
// eslint-disable-next-line react/display-name
const IntlDateRelative = React.forwardRef((props, ref) => <ConnectedIntlDateRelative forwardedRef={ref} {...props} />);
export default IntlDateRelative;
